import './classes/wooFilters';

// (function ($) {
//
//   $(function () {
//     var slider_selector = '[data-role=rangeSlider]',
//       $rangeSliders = $(slider_selector);
//
//     $rangeSliders.each(function(){
//       var $range = $(this),
//         $cont = $range.closest('fieldset'),
//         args = {};
//
//       if ( $range.data('id') === 'price' ) {
//         args['onChange'] = function(data) {
//           $cont.find('#min_price').val( data['from'] );
//           $cont.find('#max_price').val( data['to'] );
//         }
//       } else {
//         args['hide_min_max'] = true;
//         args['onChange'] = function(data) {
//           var $input = data.input,
//             from = data.from,
//             to = data.to;
//
//           if ( $input.data('grid') ) {
//             var values = $input.data('values').split(',');
//
//             var new_values = values.slice(from, to + 1);
//             $input.attr('data-current', new_values);
//           }
//         }
//       }
//
//       $range.ionRangeSlider(args);
//     });
//
//
//     $('.products-filters button[type=submit]').on('click', function (e) {
//       e.preventDefault();
//
//       $rangeSliders.each(function () {
//         var $input = $(this);
//
//         if ( $input.data('id') === 'price' ) {
//           var value = $input.val().split(';');
//           $input.val( value.join(',') );
//         } else {
//           $input.val( $input.data('current') );
//         }
//       });
//
//       $(this).closest('form').submit();
//     });
//   });
//
// })(jQuery);
